import { Card, Text } from '@zillow/constellation';
import React from 'react';
import type { TooltipProps } from 'recharts';

const ChartTooltip: TooltipProps<number, string>['content'] = (props) => {
  const { active, payload, formatter } = props;
  if (active && payload && payload.length) {
    return (
      <Card cardType="secondary">
        {payload
          .slice(0)
          .reverse()
          .map((p) => (
            <Text as="p" fontType="finePrint" key={p.name}>
              {formatter && formatter(p)}
            </Text>
          ))}
      </Card>
    );
  }
  return null;
};

export default ChartTooltip;
